<template>
  <div class="vue-utility-admin-wrap">
    <div>
        <b-spinner v-if="!utilites || !utilites.length" class="spinner"></b-spinner>
        <div
        class="add-new-button-container"
        v-if="!createUtilityFormVisible && !selectedUtility">
          <span
          class="add-new-button"
          @click="showCreateUtilityForm">+</span><span class="add-new-button-label">Add new utility</span>
        </div>
        <create-utility-form
        :utilityCreated="onUtilityCreated"
        :hideForm="hideCreateUtilityForm"
        v-if="createUtilityFormVisible && !selectedUtility"></create-utility-form>
        <div v-if="utilites && utilites.length && !createUtilityFormVisible">
            <header
            v-if="!selectedUtility"
            class="no-selected-utility">Edit Utility</header>
            <select-utility-dropdown
            v-if="utilites && !createUtilityFormVisible"
            :utilites="utilites"
            :utilitySelected="onUtilitySelected"></select-utility-dropdown>
        </div>
        <p
        class="utility-update-success-message"
        v-if="utilityUpdateSuccessMessage"
        v-bind:class="{fade: utilityUpdateSuccessMessageFade}">{{utilityUpdateSuccessMessage}}</p>
        <edit-utility-form
        :towns="towns"
        v-if="selectedUtility"
        :utilityTypes="utilityTypes"
        :utility="selectedUtility"
        :hideForm="hideEditUtilityForm"
        :utilityEditSuccess="onUtilityEditSuccess"
        :onUtilityRemoveSuccess="onUtilityRemoveSuccess"></edit-utility-form>
    </div>
  </div>
</template>

<script>
import API from "@/services/api";
import SelectUtilityDropdown from "./edit-utility/SelectUtilityDropdown";
import CreateUtilityForm from "./CreateUtilityForm";
import EditUtilityForm from "./edit-utility/EditUtilityForm";

export default {
  name: 'UtilityAdmin',
  components: {
    SelectUtilityDropdown,
    EditUtilityForm,
    CreateUtilityForm
  },
  data() {
    return {
      workflow: 'utility-list',
      towns: undefined,
      utilites: undefined,
      utilityTypes: undefined,
      selectedUtility: undefined,
      createUtilityFormVisible: false,
      utilityUpdateSuccessMessage: undefined,
      utilityUpdateSuccessMessageFade: undefined
    }
  },
  async created() {
    this.GetData();
  },
  methods: {
    cancel() {
      this.hideModal();
    },
    showCreateUtilityForm() {
      this.createUtilityFormVisible = true;
    },
    hideCreateUtilityForm() {
      this.createUtilityFormVisible = false;
    },
    hideEditUtilityForm() {
      this.selectedUtility = undefined;
    },
    onUtilitySelected(utility) {
      this.selectedUtility = JSON.parse(JSON.stringify(utility));
    },
    onUtilityCreated (utility) {
      this.hideEditUtilityForm();
      this.utilityUpdateSuccessMessage = `${utility.name} has been created`;
      API.GetUtilites().then(utilites => this.utilites = utilites || []);
      this.fadeOutUpdateSuccessMessage();
    },
    onUtilityEditSuccess(utility) {
      this.hideEditUtilityForm();
      this.utilityUpdateSuccessMessage = `${utility.name} has been updated`;
      API.GetUtilites().then(utilites => this.utilites = utilites || []);
      this.fadeOutUpdateSuccessMessage();
    },
    onUtilityRemoveSuccess(utility) {
      this.hideEditUtilityForm();
      this.utilityUpdateSuccessMessage = `${utility.name} has been removed`;
      API.GetUtilites().then(utilites => this.utilites = utilites || []);
      this.fadeOutUpdateSuccessMessage();
    },
    fadeOutUpdateSuccessMessage () {
      setTimeout(() => {this.utilityUpdateSuccessMessageFade = true}, 3000);
      setTimeout(() => {
        this.utilityUpdateSuccessMessage = undefined;
        this.utilityUpdateSuccessMessageFade = undefined;
      }, 10000);
    },
    async GetData() {
      try {
        Promise.all([
          API.GetUtilites().then(utilites => {
            this.utilites = utilites || [];
          }),
          API.GetUtilityTypes().then(utilityTypes => {
            this.utilityTypes = utilityTypes || [];
          }),
          API.GetTowns().then(towns => {
            this.towns = towns || [];
          })
        ]);
      } catch (err) {
        console.log("Unable to fetch utilites");
        console.log(err);
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../../../assets/css/partials/_variables.scss";

.vue-utility-admin-wrap{
  position: relative;
  min-height: 100px;

  header {
    &.no-selected-utility{
      margin: 20px 0 20px 5px;
      font-weight: $bold;
      color: $black;
    }
  }

  .utility-update-success-message{
      margin-top: 20px;
      font-weight: bold;
      color: #49b06b;

      -webkit-transition: all 5s ease-in-out;
      -moz-transition: all 5s ease-in-out;
      -o-transition: all 5s ease-in-out;
      transition: all 5s ease-in-out;

      &.fade{
        opacity: 0;
      }
  }
}
</style>
